module.exports = __webpack_public_path__ + "img/search.c12f43ea.svg";